// Public-page cards on the brand background (openspec: add-subtle-portal-micro-interactions).
// Inner width stays 386px on desktop (444 - 2 x 28 padding - 2 x 1 border); phones keep a 16px gutter.
const authCard = {
    width: "min(444px, calc(100vw - 32px))",
    boxSizing: "border-box",
    padding: "32px 28px",
    backgroundColor: "#FFFFFF",
    borderRadius: "25px",
    border: "1px solid #EEF1F3",
    boxShadow: "0 24px 48px -28px rgba(22, 28, 36, 0.35)",
};
export const loginContainer = {
    ...authCard,
    minHeight: "500px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
};
export const signupContainer = {
    ...authCard,
    minHeight: "600px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
};
export const signupWrper = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    gap: 1.5,
};
export const centered = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
};
export const spaceBetween = {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    alignItems: "center",
};
